(function () {
  if (!window.useKachingCart) return;

  const SHIPPING_CLASS = 'hh-kaching-footer-shipping';
  const ENHANCE_DELAYS = [80, 250, 600, 1200, 2000];
  let cartObserver = null;
  let injecting = false;

  function isSpanish() {
    return (document.documentElement.lang || '').toLowerCase().startsWith('es');
  }

  function getCartRoot() {
    return document.getElementById('kaching-cart') || document.querySelector('.kaching-cart');
  }

  function usesEssentialCart() {
    return !!document.querySelector('[data-essential-cart-element]');
  }

  function isFreeShippingUnlocked() {
    const text =
      document.querySelector('.kaching-cart__tiered-promotions-bar-text, .kaching-cart__tiered-promotions-bar p')
        ?.textContent?.toLowerCase() || '';
    return /free|gratis|congrats|felicidades|unlocked|desbloqueado/.test(text);
  }

  function getShippingCopy() {
    const free = isFreeShippingUnlocked();
    return {
      label: isSpanish() ? 'Envío' : 'Shipping',
      value: free ? (isSpanish() ? 'Gratis' : 'Free') : '—',
    };
  }

  function findFooterAnchors(scope) {
    return {
      discount: queryInCart('.kaching-cart__cart-discounts', scope),
      total:
        queryInCart('.kaching-cart__footer-total', scope) ||
        queryInCart('.kaching-cart__subtotal', scope),
      checkout: queryInCart('.kaching-cart__checkout-button', scope),
      footer: queryInCart('.kaching-cart__footer', scope),
    };
  }

  function isShippingPlaced(row, anchors) {
    if (!row?.isConnected) return false;
    if (anchors.discount) return anchors.discount.nextElementSibling === row;
    if (anchors.total) return row.nextElementSibling === anchors.total;
    if (anchors.checkout) return row.nextElementSibling === anchors.checkout;
    return anchors.footer?.contains(row);
  }

  function applyShippingStyles(label, value) {
    [label, value].forEach((el) => {
      if (!el) return;
      el.style.setProperty('font-family', 'Arial, Helvetica, sans-serif', 'important');
      el.style.setProperty('font-size', '14px', 'important');
      el.style.setProperty('font-weight', '200', 'important');
      el.style.setProperty('line-height', '1.2', 'important');
      el.style.setProperty('color', '#000', 'important');
    });
  }

  function updateShippingRow(row, copy) {
    let label = row.querySelector('[data-hh-shipping-label]');
    let value = row.querySelector('[data-hh-shipping-value]');
    if (!label || !value) {
      row.innerHTML =
        '<span data-hh-shipping-label></span><span data-hh-shipping-value></span>';
      label = row.querySelector('[data-hh-shipping-label]');
      value = row.querySelector('[data-hh-shipping-value]');
    }
    if (label && label.textContent !== copy.label) label.textContent = copy.label;
    if (value && value.textContent !== copy.value) value.textContent = copy.value;
    applyShippingStyles(label, value);
  }

  function collectShadowRoots(root, out = []) {
    if (!root) return out;
    if (root.shadowRoot) out.push(root.shadowRoot);
    root.querySelectorAll?.('*').forEach((el) => {
      if (el.shadowRoot) {
        out.push(el.shadowRoot);
        collectShadowRoots(el.shadowRoot, out);
      }
    });
    return out;
  }

  function getCartSearchRoots(scope) {
    const roots = [];
    if (!scope) return roots;
    if (scope.shadowRoot) roots.push(scope.shadowRoot);
    else roots.push(scope);
    collectShadowRoots(scope, roots);
    return [...new Set(roots)];
  }

  function queryInCart(selector, scope) {
    for (const root of getCartSearchRoots(scope)) {
      const node = root.querySelector?.(selector);
      if (node) return node;
    }
    return null;
  }

  function ensureFooterShipping() {
    if (injecting) return;

    const scope = getCartRoot();
    if (!scope) return;

    const anchors = findFooterAnchors(scope);
    if (!anchors.total && !anchors.checkout && !anchors.footer) return;

    const copy = getShippingCopy();
    let row = queryInCart(`.${SHIPPING_CLASS}`, scope);

    if (isShippingPlaced(row, anchors)) {
      updateShippingRow(row, copy);
      return;
    }

    cartObserver?.disconnect();
    injecting = true;

    try {
      if (!row) {
        row = document.createElement('div');
        row.className = SHIPPING_CLASS;
        row.innerHTML =
          '<span data-hh-shipping-label></span><span data-hh-shipping-value></span>';
      }

      updateShippingRow(row, copy);

      if (anchors.discount) anchors.discount.after(row);
      else if (anchors.total) anchors.total.before(row);
      else if (anchors.checkout) anchors.checkout.before(row);
      else anchors.footer.appendChild(row);
    } finally {
      injecting = false;
      connectCartObserver();
    }
  }

  function connectCartObserver() {
    const root = getCartRoot();
    if (!root) return;

    cartObserver?.disconnect();
    cartObserver = new MutationObserver(() => {
      if (injecting) return;
      if (!queryInCart(`.${SHIPPING_CLASS}`, root)) {
        requestAnimationFrame(ensureFooterShipping);
      }
    });
    cartObserver.observe(root, { childList: true, subtree: true });
  }

  function scheduleEnhance() {
    ENHANCE_DELAYS.forEach((delay) => {
      setTimeout(ensureFooterShipping, delay);
    });
  }

  function tryApiOpen() {
    const api = window.kachingCartApi;
    if (!api) return false;
    if (typeof api.openCart === 'function') {
      api.openCart();
      return true;
    }
    if (typeof api.open === 'function') {
      api.open();
      return true;
    }
    return false;
  }

  function showCartRoot() {
    const root = getCartRoot();
    if (!root) return false;
    root.style.setProperty('display', 'flex', 'important');
    root.style.setProperty('visibility', 'visible', 'important');
    root.style.setProperty('opacity', '1', 'important');
    root.style.setProperty('position', 'fixed', 'important');
    root.style.setProperty('inset', '0', 'important');
    root.style.setProperty('width', '100%', 'important');
    root.style.setProperty('height', '100%', 'important');
    root.style.setProperty('z-index', '999999', 'important');
    root.style.setProperty('justify-content', 'flex-end', 'important');
    root.style.setProperty('align-items', 'stretch', 'important');
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kaching-cart-open');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function openKachingCart(done) {
    if (usesEssentialCart()) {
      scheduleEnhance();
      done?.(true);
      return;
    }

    const opened = () => {
      scheduleEnhance();
      done?.(true);
    };

    if (tryApiOpen() || showCartRoot()) {
      opened();
      return;
    }

    let retries = 30;
    const retry = setInterval(() => {
      if (usesEssentialCart()) {
        clearInterval(retry);
        scheduleEnhance();
        done?.(true);
        return;
      }
      if (tryApiOpen() || showCartRoot()) {
        clearInterval(retry);
        opened();
        return;
      }
      retries -= 1;
      if (retries <= 0) {
        clearInterval(retry);
        done?.(false);
      }
    }, 100);
  }

  window.openKachingCart = openKachingCart;

  document.addEventListener(
    'click',
    (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');
      if (cartLink) {
        if (usesEssentialCart()) {
          scheduleEnhance();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        openKachingCart();
        return;
      }
      if (event.target.closest('.kaching-cart-item__quantity-btn, .kaching-cart-item__remove-btn')) {
        setTimeout(ensureFooterShipping, 300);
        return;
      }
      if (event.target.closest('.kaching-cart__inner, #cart-drawer, .kaching-cart-item, .kaching-cart__checkout-button')) return;
      if (getCartRoot() && document.documentElement.classList.contains('kaching-cart-open')) {
        document.documentElement.classList.remove('kaching-cart-open');
        document.body.classList.remove('overflow-hidden');
      }
    },
    true
  );

  function bindCartUpdates() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => openKachingCart());
  }

  function boot() {
    bindCartUpdates();
    let retries = 40;
    const retry = setInterval(() => {
      const root = getCartRoot();
      if (root) {
        clearInterval(retry);
        connectCartObserver();
        scheduleEnhance();
      } else {
        retries -= 1;
        if (retries <= 0) clearInterval(retry);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
